/**
 * @prettier
 */

import React, { useCallback } from 'react';
import SingleSampleFlow from 'cards/components/common/SingleSample/SingleSampleFlow/SingleSampleFlow';

const SingleSampleModalBase = props => {
  const {
    entryPoint,
    card,
    cardSuiteUUID,
    overrideActiveVariationUUID,
    isLetterpress,
    initialColor,
    initialForm,
    initialFlowUUID,
    initialStepKey,
    handleOpenModal,
    showCustomizeBanner,
    setModalOptions,
    closeModal,
    customizeHandler,
    isMagnet,
    nonEditableSingleSampleSku,
    skuData,
    modalContext,
    originalModalOptions,
    setModalContext,
  } = props;

  const updateOverlay = useCallback(
    value => {
      setModalContext({ showExitOverlay: value });
      setModalOptions({ hideClose: value });
    },
    [setModalContext, setModalOptions]
  );

  return (
    <SingleSampleFlow
      entryPoint={entryPoint}
      card={card}
      cardSuiteUUID={cardSuiteUUID}
      overrideActiveVariationUUID={overrideActiveVariationUUID}
      isLetterpress={isLetterpress}
      isMagnet={isMagnet}
      initialColor={initialColor}
      initialForm={initialForm}
      initialFlowUUID={initialFlowUUID}
      initialStepKey={initialStepKey}
      showCustomizeBanner={showCustomizeBanner}
      handleOpenModal={handleOpenModal}
      closeModal={closeModal}
      originalModalOptions={originalModalOptions}
      setModalOptions={setModalOptions}
      customizeHandler={customizeHandler}
      nonEditableSingleSampleSku={nonEditableSingleSampleSku}
      skuData={skuData}
      showExitOverlay={modalContext.showExitOverlay}
      setShowExitOverlay={updateOverlay}
    />
  );
};

export default SingleSampleModalBase;



// WEBPACK FOOTER //
// ./src/cards/components/common/modals/SingleSampleModal/SingleSampleModal.jsx